import { Outlet } from 'react-router'

import { usePageBrowserTabTitle } from '../../hooks'
import { NotificationProvider } from '../Notification'

import { LIBRARY_PAGE_TAB_TITLE } from './Library.constants'
import { LIBRARY_MENU } from './Library.menu'
import { LibraryMenu } from './LibraryMenu'

import * as styles from './Library.module.css'

function Library() {
  usePageBrowserTabTitle({
    pageTitle: LIBRARY_PAGE_TAB_TITLE,
  })

  return (
    <div className={styles.library}>
      <div className={styles.menu}>
        <LibraryMenu items={LIBRARY_MENU} />
      </div>
      <div className={styles.content}>
        <NotificationProvider>
          <Outlet />
        </NotificationProvider>
      </div>
    </div>
  )
}

export default Library
